import { render } from "./IRRRegularScatter.vue?vue&type=template&id=afc89ffc"
import script from "./IRRRegularScatter.vue?vue&type=script&lang=js"
export * from "./IRRRegularScatter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__